import React from 'react';
import { Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

// Frontend route guard. The backend independently enforces super-admin access
// on every /admin endpoint — this is the matching client-side gate.
export default function RequireSuperAdmin({ children }) {
  const { status, isAuthenticated, isSuperAdmin } = useAuth();

  if (status === 'initializing') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex items-center gap-2.5 text-slate-500 text-[13px]">
          <span className="h-3 w-3 rounded-full bg-brand-500 animate-pulse-soft" />
          Loading workspace…
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-md text-center">
          <span className="mx-auto mb-4 h-12 w-12 rounded-2xl bg-rose-50 text-rose-600 inline-flex items-center justify-center">
            <ShieldAlert className="h-6 w-6" />
          </span>
          <h1 className="text-[18px] font-semibold text-slate-900">Restricted area</h1>
          <p className="mt-1.5 text-[13.5px] text-slate-500">
            The Command Center is available to super administrators only. Contact your
            super admin if you believe you should have access.
          </p>
          <a
            href="/"
            className="mt-5 inline-flex items-center justify-center h-9 px-4 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors"
          >
            Back to workspace
          </a>
        </div>
      </div>
    );
  }

  return children;
}
